import { Box, Divider, Tooltip } from '@mui/material'
import { ReactComponent as UndigitizedIcon } from 'assets/Undigitized.svg'
import { getYearsOld } from 'components/shared/processes'
import { ICowLightInfo } from 'models/ICattlesData'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { hideDigitizationUi } from 'utils/companyDigitizationFeatures'
import { CardStandart } from 'ui/CardStandart'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

const InfoWidjet = (props: { cattleInfo: ICowLightInfo }) => {
	const { cattleInfo } = props
	const { userData } = useAppSelector(state => state.userReducer)
	const showUndigitizedMark =
		cattleInfo.identified === false &&
		!hideDigitizationUi(userData?.company?.id)
	const isNoDataValue = (value: unknown) =>
		value == null ||
		(typeof value === 'string' &&
			(value.trim() === '' || value.trim().toLowerCase() === 'нет данных'))

	const groupTitle = cattleInfo?.group?.title
	const collarNum = cattleInfo?.collar_num
	const tagId = cattleInfo?.tag_id
	const cowName = cattleInfo?.name
	const birthDate = cattleInfo?.birth_date
	const lactationLength = cattleInfo?.lactation_length
	const lactationCount = cattleInfo?.lactation_count

	const hasGroup = !isNoDataValue(groupTitle)
	const hasCollar = !isNoDataValue(collarNum)
	const hasTagId = !isNoDataValue(tagId)
	const hasName = !isNoDataValue(cowName)
	const hasBirthDate = !isNoDataValue(birthDate)
	const hasLactation =
		!isNoDataValue(lactationLength) && !isNoDataValue(lactationCount)

	const hasTopBlock = hasGroup || hasCollar || hasTagId || hasName
	const hasBottomBlock = hasBirthDate || hasLactation

	if (!hasTopBlock && !hasBottomBlock) {
		return null
	}

	return (
		<CardStandart sx={{ padding: '20px', height: '100%', width: '100%' }}>
			<Box display={'flex'} flexDirection={'column'} gap={'10px'}>
				<TypographyHeader sx={{ marginBottom: '2px' }}>
					Общая информация
				</TypographyHeader>
				<Box display='flex' flexDirection='column' gap='10px'>
					{hasGroup && (
						<TypographyPrimary>
							<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
								Группа:
							</span>
							{groupTitle}
						</TypographyPrimary>
					)}
					{hasCollar && (
						<TypographyPrimary>
							<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
								Номер ошейника:
							</span>
							{collarNum}
						</TypographyPrimary>
					)}
					{hasTagId && (
						<Box display='flex' alignItems='center' gap='4px'>
							<TypographyPrimary>
								<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
									Номер ушной бирки:
								</span>
								<span
									style={{
										color: showUndigitizedMark ? COLORS.error : COLORS.black,
									}}
								>
									{tagId}
								</span>
							</TypographyPrimary>
							{showUndigitizedMark && (
								<Tooltip
									title='Корова не оцифрована.'
									arrow
									componentsProps={{
										tooltip: {
											sx: {
												backgroundColor: '#fff',
												color: COLORS.error,
												boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
											},
										},
										arrow: {
											sx: {
												color: '#fff',
											},
										},
									}}
								>
									<Box display='flex'>
										<UndigitizedIcon width={16} height={16} />
									</Box>
								</Tooltip>
							)}
						</Box>
					)}
					{hasName && (
						<TypographyPrimary>
							<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
								Кличка:
							</span>
							{cowName}
						</TypographyPrimary>
					)}
				</Box>

				{hasTopBlock && hasBottomBlock && <Divider sx={{ my: '2px' }} />}

				<Box display='flex' flexDirection='column' gap='10px'>
					{hasBirthDate && (
						<TypographyPrimary>
							<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
								Возраст:
							</span>
							{getYearsOld(birthDate)}
						</TypographyPrimary>
					)}
					{hasLactation && (
						<TypographyPrimary>
							<span style={{ color: COLORS.secondary, marginRight: '8px' }}>
								Текущая лактация:
							</span>
							{`${lactationLength} дней, лактация №${lactationCount}`}
						</TypographyPrimary>
					)}
				</Box>
			</Box>
		</CardStandart>
	)
}

export default InfoWidjet
